import { Component, ViewEncapsulation } from '@angular/core';
import { DateService } from '@app/services/date.service';
import { TranslateService } from '@ngx-translate/core';
import { MessageService } from 'primeng/api';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { environment } from '@environments/environment';


@Component({
	templateUrl: './popupFromToReason.component.html',
	styleUrls: [ './style.scss'	],
	encapsulation: ViewEncapsulation.None
})

export class PopupFromToReasonComponent {
	loading = 0;
	selectedTimespan = 0;
	fromDate = new Date();
	toDate = new Date();
	reason = "";
	env_supportmail: string = '';

	constructor(
		public config: DynamicDialogConfig,
		private messageService: MessageService,
		public ref: DynamicDialogRef,
		public translate: TranslateService,
		public dateService: DateService
	) {
		this.env_supportmail = environment.supportEmail;
		if(!this.env_supportmail || this.env_supportmail.trim().length < 1) {
			this.env_supportmail = 'support@visy-gmbh.com';
		}
	}

	convertTimespanSelection(event) {
		const timespan = this.dateService.getTimespan(event.value);
		if (timespan != null) {
			this.fromDate = timespan.fromDate;
			this.toDate = timespan.toDate;
		}
	}

	inputDate(dateField, input: string) {
		console.log("input date = ", input);
		let date = DateService.inputDateExStatic(input);
		if (date) {
			if (dateField == 'fromDate') {
				this.fromDate = date;
			} else if (dateField == 'toDate') {
				this.toDate = date;
			}
			this.selectedTimespan = -1;
		}
	}

	setTime(input: Date, HH : number, MM : number, SS : number ): Date {
		var y, m, d, hh, mm, ss, ms;
		y = input.getFullYear();
		m = input.getMonth();
		d = input.getDate();
		hh = input.getHours();
		mm = input.getMinutes();
		ss = input.getSeconds();
		ms = input.getMilliseconds();
		return new Date(y, m, d, HH, MM, SS, 0);
	}

	save(): void {
		// hier wird die lokalzeit zur�ckgeliefert, das ist korrekt !
		this.fromDate = this.fromDate ? this.setTime(this.fromDate as Date, 0, 0, 0) : null;
		this.toDate = this.toDate ? this.setTime(this.toDate as Date, 23, 59, 59) : null;

		this.ref.close(<JSON><unknown>{
			"fromDate": this.fromDate,
			"toDate": this.toDate,
			"reason": this.reason
		});
	}

	cancel(): void {
		this.ref.close(null);
	}
}